// import { useAuth } from '../hooks/useAuth';

export default function ReportsPage() {
     // const { user } = useAuth(); // Commented out as not currently used

     return (
          <div>
               <div className="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 className="h3 mb-0 text-gray-800">Reports & Analytics</h1>
                    <button className="btn btn-primary">
                         <i className="fas fa-download mr-2"></i>
                         Export Report
                    </button>
               </div>

               {/* Report Cards */}
               <div className="row">
                    <div className="col-xl-3 col-md-6 mb-4">
                         <div className="card border-left-primary shadow h-100 py-2">
                              <div className="card-body">
                                   <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                             <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                                  Total Studies
                                             </div>
                                             <div className="h5 mb-0 font-weight-bold text-gray-800">1,247</div>
                                        </div>
                                        <div className="col-auto">
                                             <i className="fas fa-file-medical fa-2x text-gray-300"></i>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>

                    <div className="col-xl-3 col-md-6 mb-4">
                         <div className="card border-left-success shadow h-100 py-2">
                              <div className="card-body">
                                   <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                             <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                                                  This Month
                                             </div>
                                             <div className="h5 mb-0 font-weight-bold text-gray-800">156</div>
                                        </div>
                                        <div className="col-auto">
                                             <i className="fas fa-calendar-check fa-2x text-gray-300"></i>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>

                    <div className="col-xl-3 col-md-6 mb-4">
                         <div className="card border-left-info shadow h-100 py-2">
                              <div className="card-body">
                                   <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                             <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                                                  Accuracy Rate
                                             </div>
                                             <div className="row no-gutters align-items-center">
                                                  <div className="col-auto">
                                                       <div className="h5 mb-0 mr-3 font-weight-bold text-gray-800">97.2%</div>
                                                  </div>
                                                  <div className="col">
                                                       <div className="progress progress-sm mr-2">
                                                            <div className="progress-bar bg-info" style={{ width: '97.2%' }}></div>
                                                       </div>
                                                  </div>
                                             </div>
                                        </div>
                                        <div className="col-auto">
                                             <i className="fas fa-bullseye fa-2x text-gray-300"></i>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>

                    <div className="col-xl-3 col-md-6 mb-4">
                         <div className="card border-left-warning shadow h-100 py-2">
                              <div className="card-body">
                                   <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                             <div className="text-xs font-weight-bold text-warning text-uppercase mb-1">
                                                  Avg. Time
                                             </div>
                                             <div className="h5 mb-0 font-weight-bold text-gray-800">12.5 min</div>
                                        </div>
                                        <div className="col-auto">
                                             <i className="fas fa-clock fa-2x text-gray-300"></i>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>

               {/* Charts Row */}
               <div className="row">
                    <div className="col-xl-8 col-lg-7">
                         <div className="card shadow mb-4">
                              <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                   <h6 className="m-0 font-weight-bold text-primary">Monthly Performance</h6>
                              </div>
                              <div className="card-body">
                                   <div className="chart-area">
                                        <div className="text-center py-5">
                                             <i className="fas fa-chart-line fa-4x text-gray-300 mb-3"></i>
                                             <p className="text-muted">Performance chart will be displayed here</p>
                                             <small className="text-muted">Integration with charting library required</small>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>

                    <div className="col-xl-4 col-lg-5">
                         <div className="card shadow mb-4">
                              <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                   <h6 className="m-0 font-weight-bold text-primary">Study Types</h6>
                              </div>
                              <div className="card-body">
                                   <div className="chart-pie pt-4 pb-2">
                                        <div className="text-center">
                                             <i className="fas fa-chart-pie fa-4x text-gray-300 mb-3"></i>
                                             <p className="text-muted">Study distribution chart</p>
                                        </div>
                                   </div>
                                   <div className="mt-4 text-center small">
                                        <span className="mr-2">
                                             <i className="fas fa-circle text-primary"></i> CT Scans
                                        </span>
                                        <span className="mr-2">
                                             <i className="fas fa-circle text-success"></i> MRI
                                        </span>
                                        <span className="mr-2">
                                             <i className="fas fa-circle text-info"></i> X-Ray
                                        </span>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>

               {/* Recent Activity */}
               <div className="row">
                    <div className="col-12">
                         <div className="card shadow mb-4">
                              <div className="card-header py-3">
                                   <h6 className="m-0 font-weight-bold text-primary">Recent Activity</h6>
                              </div>
                              <div className="card-body">
                                   <div className="table-responsive">
                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                             <thead>
                                                  <tr>
                                                       <th>Date</th>
                                                       <th>Study Type</th>
                                                       <th>Patient ID</th>
                                                       <th>Time Taken</th>
                                                       <th>Status</th>
                                                  </tr>
                                             </thead>
                                             <tbody>
                                                  <tr>
                                                       <td>2025-03-20</td>
                                                       <td>CT Chest</td>
                                                       <td>P-12345</td>
                                                       <td>15 min</td>
                                                       <td><span className="badge badge-success">Completed</span></td>
                                                  </tr>
                                                  <tr>
                                                       <td>2025-03-20</td>
                                                       <td>MRI Brain</td>
                                                       <td>P-12346</td>
                                                       <td>22 min</td>
                                                       <td><span className="badge badge-success">Completed</span></td>
                                                  </tr>
                                                  <tr>
                                                       <td>2025-03-19</td>
                                                       <td>X-Ray Chest</td>
                                                       <td>P-12347</td>
                                                       <td>8 min</td>
                                                       <td><span className="badge badge-success">Completed</span></td>
                                                  </tr>
                                                  <tr>
                                                       <td>2025-03-19</td>
                                                       <td>CT Abdomen</td>
                                                       <td>P-12348</td>
                                                       <td>18 min</td>
                                                       <td><span className="badge badge-warning">Under Review</span></td>
                                                  </tr>
                                                  <tr>
                                                       <td>2025-03-18</td>
                                                       <td>MRI Spine</td>
                                                       <td>P-12349</td>
                                                       <td>25 min</td>
                                                       <td><span className="badge badge-success">Completed</span></td>
                                                  </tr>
                                             </tbody>
                                        </table>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
     );
}